import React, { useMemo } from 'react';
import styles from './Bars.module.css';

export default function Bars({downloads, views}) {

    const bars = useMemo(() => [
        {height: Math.floor(Math.random() * 81) + 20, color: '#364957'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#8e8e8e'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#364957'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#8e8e8e'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#8e8e8e'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#364957'},
        {height: Math.floor(Math.random() * 81) + 20, color: '#364957'},
    ], [downloads, views]);

    return (
        <div className={styles.container}>
            {bars.map((bar, i) => (
                <div key={i} className={styles.bar} style={{height: `${bar.height}%`, backgroundColor: bar.color}} />
            ))}
        </div>
    );
};